import { useCommandPalette } from '@web/data/repositories';
import { useMetaKeyShortcut } from '@web/ui/core/hooks';

/**
 * Registers the global Cmd/Ctrl-K shortcut to toggle the palette. Mount
 * once, in the authenticated app shell.
 */
export function useCommandPaletteShortcut(): void {
  const toggle = useCommandPalette((s) => s.toggle);
  useMetaKeyShortcut('k', toggle);
}
